import { RevisionRow } from 'components/tables/data/revision/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the revision ID.
 */
export default function RevisionIdColumn({ data: { revisionId } }: { data: RevisionRow }) {
  return <P3Regular color="gray.8">{revisionId}</P3Regular>;
}
